<template>
    <CDropdown inNav
               class="c-header-nav-items notification-dropdown-menu"
               placement="bottom-end"
               add-menu-classes="pt-0">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <CIcon name="cil-bell" />
                    <CBadge color="warning" class="ml-auto">{{ unreadMessageCount }}</CBadge>
                </div>
            </CHeaderNavLink>
        </template>
        <template>
            <CDropdownHeader tag="div" class="text-center" color="light">
                <strong class="pull-left">Thông báo</strong>
                <a href="#" @click="markReadAll" class="pull-right" v-if="unreadMessageCount > 0">Đánh dấu đã đọc</a>
                <div class="clearfix"></div>
            </CDropdownHeader>
            <div class="dropdown-menu-content">
                <CDropdownItem v-for="item in notifications" :key="item.id" :to="{ path: getPathUrl(item) }">
                    <div class="message" v-bind:class="{ unread: !item.isRead }" @click="markRead(item)">
                        <div><i class="text-muted">{{ item.senderUnitName }}</i><i class="text-muted float-right mt-1">{{ item.createdDate | formatTime }}</i></div>
                        <div class="text-truncate font-weight-bold">
                            <template v-if="item.syncStatus">
                                <CIcon name="cil-info" class="text-success" /> Đồng bộ thành công
                            </template>
                            <template v-else>
                                <CIcon name="cil-warning" class="text-danger" /> Đồng bộ thất bại
                            </template>
                        </div>
                        <div class="text-muted text-truncate" v-html="getDescription(item)"></div>
                    </div>
                </CDropdownItem>
                <infinite-loading @infinite="infiniteHandler" ref="notificationLoader">
                    <template v-slot:no-more>
                        <span></span>
                    </template>
                </infinite-loading>
            </div>
        </template>
    </CDropdown>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        name: 'TheHeaderDropdownNotification',
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                unreadMessageCount: 0,
                notifications: []
            }
        },
        computed: {
            lastNotificationId() {
                if (this.notifications.length == 0) {
                    return '';
                } else {
                    return this.notifications[this.notifications.length - 1].id;
                }
            }
        },
        created() {
            this.getNewNotificationCount();
        },
        mounted() {
            this.infiniteHandler(this.$refs.notificationLoader.stateChanger);
        },
        methods: {
            getNewNotificationCount() {
                var vm = this;
                this.$services.get('notifications/new').done(count => vm.unreadMessageCount = count);
            },
            markRead(item) {
                var vm = this;
                if (!item.isRead) {
                    this.$services.put(`notifications/mark-read/${item.id}`, null, { showLoading: false }).done(() => {
                        item.isRead = true;
                        if (vm.unreadMessageCount > 0) {
                            vm.unreadMessageCount--;
                        }
                    });
                }
            },
            markReadAll() {
                var vm = this;
                this.$services.put(`notifications/mark-read`).done(() => {
                    for (var i = 0; i < vm.notifications.length; i++) {
                        notifications[i].isRead = true;
                    }
                    vm.unreadMessageCount = 0;
                });
            },
            getDescription(item) {
                var action = this.$store.getters.getActionName(item.actionType);
                var status = this.$store.getters.getStatusName(item.syncStatus ? 1 : 0).toLowerCase();
                var target;
                if (item.syncType == 1) {
                    target = this.$store.getters.getAssetInfoSyncTypeName(item.infoType);
                } else {
                    target = this.$store.getters.getReportSyncTypeName(item.infoType);
                }
                var errorMessage = '';
                if (!item.syncStatus && item.totalInvalidItems) {
                    errorMessage = ` (${item.totalInvalidItems} bản ghi không hợp lệ)`;
                }

                return `${action} ${status} <b>${item.totalItems || 1}</b> <i>${target}${errorMessage}</i>.`;
            },
            getPathUrl(item) {
                if (item.syncType == 1) {
                    if (item.syncStatus == 1) {
                        if (item.infoType == 11 || item.infoType == 12 || item.infoType == 13) {
                            return `/help/notifications/asset-exploitation-subs/${item.syncLogId}`;
                        } else {
                            return `/help/notifications/asset-info-subs/${item.syncLogId}`;
                        }
                    } else {
                        if (item.infoType == 11 || item.infoType == 12 || item.infoType == 13) {
                            return `/help/notifications/asset-exploitation-error/${item.syncLogId}`;
                        } else {
                            return `/help/notifications/asset-info-error/${item.syncLogId}`;
                        }
                    }
                } else {
                    if (item.syncStatus == 1) {
                        return `/help/notifications/report-subs/${item.syncLogId}`;
                    } else {
                        return `/help/notifications/report-error/${item.syncLogId}`;
                    }
                }
            },
            infiniteHandler($state) {
                var vm = this;

                return this.$services.get(`notifications/next/${this.lastNotificationId}`).done(data => {
                    if (data.length > 0) {
                        vm.notifications = vm.notifications.concat(data);

                        $state.loaded();

                        resize();
                    } else {
                        $state.complete();
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .c-icon {
        margin-right: 0.3rem;
    }

    .message {
        width: 100%;
    }

        .message.unread {
            font-weight: bold;
        }
</style>